module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-pediatric-appointment"
  }, [_c('div', {
    staticClass: "pages-pediatric-appointment__container"
  }, [_vm._m(0), _c('Form')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-pediatric-appointment__title"
  }, [_c('h2', [_vm._v("Request a Pediatric Appointment")]), _c('br'), _c('p', [_vm._v("Thank you for your interest in our clinic. Please fill out the form below to request an appointment with our board-certified pediatric dentist. One of our team members will contact you as soon as possible to schedule a time that is convenient for you to come in. ")]), _c('br'), _c('p', [_vm._v("In the meantime please feel free to get to know us on social media! ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe43bb44","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/pediatric-appointment/pediatric-appointment.pug
// module id = 731
// module chunks = 1